var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2ReportStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_835_774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.73083 5.96421C6.92747 5.96421 7.0995 5.89051 7.24695 5.74305C7.39441 5.59559 7.46812 5.42356 7.46812 5.22693C7.46812 5.03033 7.39441 4.8583 7.24695 4.71084C7.0995 4.56339 6.92747 4.48964 6.73083 4.48964C6.53424 4.48964 6.36221 4.56339 6.21475 4.71084C6.06729 4.8583 5.99354 5.03033 5.99354 5.22693C5.99354 5.42356 6.06729 5.59559 6.21475 5.74305C6.36221 5.89051 6.53424 5.96421 6.73083 5.96421ZM6.73083 10.1668C6.92747 10.1668 7.0995 10.093 7.24695 9.94557C7.39441 9.79811 7.46812 9.62609 7.46812 9.42949C7.46812 9.23289 7.39441 9.06087 7.24695 8.91337C7.0995 8.76591 6.92747 8.6922 6.73083 8.6922C6.53424 8.6922 6.36221 8.76591 6.21475 8.91337C6.06729 9.06087 5.99354 9.23289 5.99354 9.42949C5.99354 9.62609 6.06729 9.79811 6.21475 9.94557C6.36221 10.093 6.53424 10.1668 6.73083 10.1668ZM6.73083 14.3693C6.92747 14.3693 7.0995 14.2956 7.24695 14.1481C7.39441 14.0007 7.46812 13.8286 7.46812 13.632C7.46812 13.4354 7.39441 13.2634 7.24695 13.1159C7.0995 12.9685 6.92747 12.8947 6.73083 12.8947C6.53424 12.8947 6.36221 12.9685 6.21475 13.1159C6.06729 13.2634 5.99354 13.4354 5.99354 13.632C5.99354 13.8286 6.06729 14.0007 6.21475 14.1481C6.36221 14.2956 6.53424 14.3693 6.73083 14.3693ZM3.56051 18.2769C3.16729 18.2769 2.82323 18.1295 2.52831 17.8346C2.23339 17.5397 2.08594 17.1956 2.08594 16.8024V2.05661C2.08594 1.66339 2.23339 1.31932 2.52831 1.0244C2.82323 0.729489 3.16729 0.582031 3.56051 0.582031H14.3004C14.4969 0.582031 14.6895 0.62299 14.8779 0.704911C15.0663 0.786833 15.2261 0.893331 15.3571 1.0244L19.3385 5.00576C19.4695 5.13682 19.576 5.29657 19.658 5.48499C19.7399 5.67341 19.7809 5.86594 19.7809 6.06253V16.8024C19.7809 17.1956 19.6334 17.5397 19.3385 17.8346C19.0436 18.1295 18.6995 18.2769 18.3063 18.2769H3.56051ZM14.1037 2.05661V5.52184C14.1037 5.73487 14.1734 5.91097 14.3126 6.05025C14.4519 6.18953 14.628 6.25913 14.841 6.25913H18.3063L14.1037 2.05661Z",
    fill: "#B9B9B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_835_774",
    x: 0.458819,
    y: 0.582031,
    width: 20.9495,
    height: 20.9495,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.62712
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.813559
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_835_774"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_835_774",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2ReportStandard);
export default __webpack_public_path__ + "static/media/v2-report-standard.fabdc4e396f446a913abcbd96ee5b9d1.svg";
export { ForwardRef as ReactComponent };